import React, { useState } from 'react';
import { Question, } from '../../types/models';
import { CreateQuestionData } from '../../services/questionService';
import { Input } from '../common/Input';
import { Button } from '../common/Button';

interface EditQuestionFormProps {
  question: Question;
  onSave: (data: Partial<CreateQuestionData>) => Promise<void>;
  onCancel: () => void;
}

export const EditQuestionForm: React.FC<EditQuestionFormProps> = ({ question, onSave, onCancel }) => {
  const [text, setText] = useState(question.text);
  const [optionA, setOptionA] = useState(question.optionA);
  const [optionB, setOptionB] = useState(question.optionB);
  const [optionC, setOptionC] = useState(question.optionC);
  const [correctOptions, setCorrectOptions] = useState<Array<'A' | 'B' | 'C'>>(question.correctOptions);
  const [imageFile, setImageFile] = useState<File | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  const handleCorrectOptionChange = (option: 'A' | 'B' | 'C') => {
    setCorrectOptions(prev =>
      prev.includes(option)
        ? prev.filter(item => item !== option)
        : [...prev, option]
    );
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files[0]) {
      setImageFile(event.target.files[0]);
    }
  };

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    setIsLoading(true);
    await onSave({ text, optionA, optionB, optionC, correct_options: correctOptions, imageFile });
    setIsLoading(false);
  };

  return (
    <form onSubmit={handleSubmit} style={{ background: '#f8f8f8', padding: 16, borderRadius: 8, marginBottom: 16 }}>
      <h4>Edytuj pytanie</h4>
      <Input id="edit-question-text" label="Treść pytania" value={text} onChange={e => setText(e.target.value)} required />
      <Input id="edit-option-a" label="Odpowiedź A" value={optionA} onChange={e => setOptionA(e.target.value)} required />
      <Input id="edit-option-b" label="Odpowiedź B" value={optionB} onChange={e => setOptionB(e.target.value)} required />
      <Input id="edit-option-c" label="Odpowiedź C" value={optionC} onChange={e => setOptionC(e.target.value)} required />
      <div>
        <label>
          <input type="checkbox" checked={correctOptions.includes('A')} onChange={() => handleCorrectOptionChange('A')} /> Poprawna A
        </label>
        <label style={{ marginLeft: 8 }}>
          <input type="checkbox" checked={correctOptions.includes('B')} onChange={() => handleCorrectOptionChange('B')} /> Poprawna B
        </label>
        <label style={{ marginLeft: 8 }}>
          <input type="checkbox" checked={correctOptions.includes('C')} onChange={() => handleCorrectOptionChange('C')} /> Poprawna C
        </label>
      </div>
      <div style={{ marginTop: 8 }}>
        <input type="file" accept="image/*" onChange={handleFileChange} />
      </div>
      <div style={{ marginTop: 12, display: 'flex', gap: 8 }}>
        <Button type="submit" disabled={isLoading}>Zapisz</Button>
        <Button type="button" variant="secondary" onClick={onCancel}>Anuluj</Button>
      </div>
    </form>
  );
};
